module.exports = __webpack_public_path__ + "img/deposit.65ed8e2e.png";